import React from 'react'
import Header from '../../Components/Header'
import WireProductionCapabilities from '../../Components/wireProductionCapabilties'
import wireProduciton1 from "../../imagens/wireProduction/wireProduction1.png"
import wireProduciton2 from "../../imagens/wireProduction/wireProduction2.png"
import wireProduciton3 from "../../imagens/wireProduction/wireProduction3.png"
import wireProduciton4 from "../../imagens/wireProduction/wireProduction4.png"
import wireProduciton5 from "../../imagens/wireProduction/wireProduction5.png"
import wireProduciton6 from "../../imagens/wireProduction/wireProduction6.png"
import wireProduciton7 from "../../imagens/wireProduction/wireProduction7.jpeg"
import wireProduciton8 from "../../imagens/wireProduction/wireProduction8.jpeg"
import wireProduciton9 from "../../imagens/wireProduction/wireProduction9.jpeg"
import wireProduciton10 from "../../imagens/wireProduction/wireProduction10.jpeg"
import wireProduciton11 from "../../imagens/wireProduction/wireProduction11.jpeg"
import wireProduciton12 from "../../imagens/wireProduction/wireProduction12.jpeg"
import wireProduciton13 from "../../imagens/wireProduction/wireProduction13.jpeg"
import wireProduciton14 from "../../imagens/wireProduction/wireProduction14.jpeg"
import wireProduciton15 from "../../imagens/wireProduction/wireProduction15.jpeg"


const wireProductionList = [

    {
        img:wireProduciton1
    },
    {
        img:wireProduciton2
    },
    {
        img:wireProduciton3
    },
    {
        img:wireProduciton4
    },
    {
        img:wireProduciton5
    },
    {
        img:wireProduciton6
    },
    {
        img:wireProduciton7
    },
    {
        img:wireProduciton8
    },
    {
        img:wireProduciton9
    },
    {
        img:wireProduciton10
    },
    {
        img:wireProduciton11
    },
    {
        img:wireProduciton12
    },
    {
        img:wireProduciton13
    },
    {
        img:wireProduciton14
    },
    {
        img:wireProduciton15
    },

]




function WireProductionPage() {
    return (
        <div>
            <Header/>

            <WireProductionCapabilities
                wireProductionList = {wireProductionList}
                />
        </div>
    )
}

export default WireProductionPage